import PropTypes from 'prop-types';

import { Button, Link, Paragraph } from '@cof/plastic-components';

import BodySection from '../../components/BodySection';
import Header from '../../components/Header';
import Main from '../../components/Main';
import TitleSection, { TitleSectionHeading } from '../../components/TitleSection';
import { withText } from '../../text/textStore';
import { css, styled } from 'styled-components';

export const DeclineTitleSection = styled(TitleSection)`
    ${({ theme }: any) => css`
        ${theme.components.HeroWrapper}
    `}
`;
DeclineTitleSection.displayName = 'DeclineTitleSection';

const AlreadyAppliedDecline = ({ Text, Text: text, TemplateText, JsxText, firstName }: any) => {
    return (
        <>
            <Header isDeclinePage={true} />
            <Main bg="global.white" data-qa-id="already-applied-decline-page">
                <DeclineTitleSection>
                    <TitleSectionHeading>
                        <TemplateText path="Title" params={{ NAME: firstName }} />
                    </TitleSectionHeading>
                </DeclineTitleSection>
                <BodySection textAlign="center" data-qa-id="body">
                    <Paragraph data-qa-id="page-paragraph1" whiteSpace="pre-wrap" data-qm-allow>
                        <Text path="Paragraph1" />
                    </Paragraph>
                    <Paragraph data-qa-id="page-paragraph2" data-qm-allow>
                        <JsxText
                            path="Paragraph2"
                            params={{
                                CONTACT: (
                                    <Link href={text({ path: 'ContactUsLink' })} data-qm-allow>
                                        <Text path="ContactUs" />
                                    </Link>
                                )
                            }}
                        />
                    </Paragraph>
                    <Button
                        mt="md"
                        as="a"
                        data-qa-id="homepage-link"
                        href={text({ path: 'HomePageLink' })}
                        data-qm-allow
                    >
                        <Text path="HomePage" />
                    </Button>
                </BodySection>
            </Main>
        </>
    );
};

AlreadyAppliedDecline.propTypes = {
    Text: PropTypes.func.isRequired,
    TemplateText: PropTypes.func.isRequired,
    JsxText: PropTypes.func.isRequired,
    firstName: PropTypes.string.isRequired
};

const AlreadyAppliedDeclineWithText = withText('AlreadyAppliedDecline')(AlreadyAppliedDecline);
AlreadyAppliedDeclineWithText.displayName = 'AlreadyAppliedDecline';

export default AlreadyAppliedDeclineWithText;
